import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';

import { ApiProvider } from '../../providers/api/api';
import { HelpersProvider } from '../../providers/helpers/helpers';
import { DialogLightComponent } from '../../ui/dialog-light/dialog-light';

@Component({
  selector: 'app-adm-indicacoes',
  templateUrl: './adm-indicacoes.component.html',
})
export class AdmIndicacoesComponent implements OnInit {
  reports: any[] = [];
  pageSize: number = 10;
  pageIndex: number = 0;
  length: number = 0;
  loading: boolean = false;
  savingId: any = 0;
  savingRules: boolean = false;
  loadError: string = '';
  commissionRulesError: string = '';
  commissionRules: any[] = [];

  paymentStatusOptions = [
    { value: 'registered', label: 'Não se aplica' },
    { value: 'pending', label: 'Em andamento' },
    { value: 'paid', label: 'Pago' },
  ];

  @ViewChild('paginator') paginator: MatPaginator;

  constructor(
    public api: ApiProvider,
    public dialog: MatDialog,
    public helpers: HelpersProvider,
    public toastr: ToastrService,
  ) {
    this.commissionRules = this.defaultCommissionRules();
  }

  ngOnInit() {
    this.loadReports();
    this.loadCommissionRules();
  }

  reportsPage() {
    return this.reports;
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadReports();
  }

  loadReports() {
    this.loading = true;
    this.loadError = '';
    this.api.get('v3/referral/master/teacher-referrals', {
      params: {
        page: this.pageIndex + 1,
        per_page: this.pageSize,
      }
    }).then((res: any) => {
      const data = res && res.reports ? res.reports : {};
      this.reports = (data.data || []).map((row: any) => this.normalizeReport(row));
      this.length = data.total || 0;
      this.loading = false;
    }).catch((_err: any) => {
      this.reports = [];
      this.length = 0;
      this.loadError = 'Não foi possível carregar as indicações.';
      this.loading = false;
    });
  }

  loadCommissionRules() {
    this.commissionRulesError = '';
    this.api.get('v3/referral/master/commission-rules').then((res: any) => {
      this.commissionRules = (res && res.rules ? res.rules : []).map((rule: any) => this.normalizeCommissionRule(rule));
    }).catch((_err: any) => {
      this.commissionRules = this.defaultCommissionRules();
      this.commissionRulesError = 'Não foi possível carregar os valores salvos. Exibindo valores padrão.';
    });
  }

  saveCommissionRules() {
    this.savingRules = true;
    const rules = this.commissionRules.map((rule: any) => {
      return {
        supertreinos_plan_id: rule.supertreinos_plan_id,
        amount_cents: this.currencyToCents(rule.amount),
        active: true,
      };
    });

    this.api.put('v3/referral/master/commission-rules', { rules }).then((res: any) => {
      this.commissionRules = (res && res.rules ? res.rules : []).map((rule: any) => this.normalizeCommissionRule(rule));
      this.savingRules = false;
      this.toastr.success('Comissões atualizadas com sucesso.', '', this.helpers.toastrCfgs);
    }).catch((err: any) => {
      this.savingRules = false;
      this.commissionRulesError = 'Não foi possível salvar as comissões.';
      this.toastr.error((err && err.error && err.error.err) || 'Não foi possível salvar as comissões.', '', this.helpers.toastrCfgs);
    });
  }

  changePaymentStatus(row: any, status: string) {
    if (!row) return;
    if (row.bonus_status === status) {
      return;
    }

    const previous = row.bonus_status;
    row.bonus_status = status;
    this.savingId = row.id;

    this.api.put('v3/referral/master/teacher-referrals/' + row.id + '/status', {
      bonus_status: status,
    }).then((res: any) => {
      const updated = res && res.referral ? this.normalizeReport(res.referral) : row;
      Object.assign(row, updated);
      this.savingId = 0;
      this.toastr.success('Status atualizado com sucesso.', '', this.helpers.toastrCfgs);
    }).catch((err: any) => {
      row.bonus_status = previous;
      row.paymentStatus = this.formatPaymentStatus(row);
      this.savingId = 0;
      this.toastr.error((err && err.error && err.error.err) || 'Não foi possível atualizar o status.', '', this.helpers.toastrCfgs);
    });
  }

  normalizeReport(row: any) {
    const paymentExpected = this.isPaymentExpected(row);
    return {
      id: row.id,
      date: this.formatDate(row.date),
      referrerEmail: row.referrer_email || '-',
      referredEmail: row.referred_email || row.email || '-',
      status: row.premium ? 'Premium' : 'Gratuito',
      commission: row.premium ? this.formatCurrency(row.commission_amount_cents, row.commission_currency) : this.formatCurrency(0, row.commission_currency),
      paymentStatus: this.formatPaymentStatus(row),
      premium: row.premium,
      paymentExpected,
      bonus_status: row.bonus_status || 'registered',
      payment_date: row.payment_date,
      paid_at: row.paid_at,
      payoutAccount: row.payout_account || null,
      editable: row.editable !== false,
    };
  }

  normalizeCommissionRule(rule: any) {
    return {
      id: rule.id || null,
      supertreinos_plan_id: rule.supertreinos_plan_id,
      label: rule.label || 'Plano',
      amount: this.centsToCurrency(rule.amount_cents),
    };
  }

  defaultCommissionRules() {
    return [
      { id: null, supertreinos_plan_id: null, label: 'Padrão', amount: '25.00' },
      { id: null, supertreinos_plan_id: '1', label: 'Basic', amount: '25.00' },
      { id: null, supertreinos_plan_id: '2', label: 'Standard', amount: '25.00' },
      { id: null, supertreinos_plan_id: '3', label: 'Pro', amount: '25.00' },
      { id: null, supertreinos_plan_id: '4', label: 'Black', amount: '25.00' },
    ];
  }

  centsToCurrency(amountCents: number) {
    return ((amountCents || 0) / 100).toFixed(2);
  }

  currencyToCents(value: any) {
    const normalized = String(value || '0').replace(',', '.');
    return Math.round((parseFloat(normalized) || 0) * 100);
  }

  openPayoutAccount(row: any) {
    const account = row && row.payoutAccount ? row.payoutAccount : null;
    const message = account ? `
      <p><strong>Chave pix:</strong> ${this.escapeHtml(account.pix_key || '-')}</p>
      <p><strong>Banco:</strong> ${this.escapeHtml(account.bank || '-')}</p>
      <p><strong>Nome completo:</strong> ${this.escapeHtml(account.holder_name || '-')}</p>
    ` : '<p>Não há dados de pagamento cadastrados para este usuário.</p>';

    this.dialog.open(DialogLightComponent, {
      width: '420px',
      data: {
        title: row.referrerEmail || 'Dados de pagamento',
        message,
        confirmation: 'ok',
        bt_ok: 'Fechar',
      }
    });
  }

  escapeHtml(value: string) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  formatPaymentStatus(row: any) {
    if (!row || row.bonus_status === 'registered') {
      return '-';
    }
    if (row.bonus_status === 'paid') {
      return 'Pago em ' + this.formatDate(row.payment_date || row.paid_at);
    }
    return 'Previsto para ' + this.formatDate(row.payment_date);
  }

  isPaymentExpected(row: any) {
    return row && row.bonus_status !== 'registered' && row.bonus_status !== 'paid';
  }

  paymentStatusClass(row: any) {
    if (!row || row.bonus_status === 'registered') {
      return '';
    }
    return row.bonus_status === 'paid' ? 'paid' : 'expected';
  }

  formatCurrency(amountCents: number, currency: string = 'BRL') {
    const value = (amountCents || 0) / 100;
    return value.toLocaleString('pt-BR', { style: 'currency', currency: currency || 'BRL' });
  }

  formatDate(date: string) {
    if (!date) return '-';
    const parts = date.substring(0, 10).split('-');
    if (parts.length !== 3) return date;
    return parts[2] + '/' + parts[1] + '/' + parts[0];
  }
}
